module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.eb43b4c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/font/roboto/Roboto-Bold.woff
// module id = c+l/
// module chunks = 0